// Resume-overlay helper (Requirements 5.3, 4.5).
//
// When a Learner resumes a Saved_Session, the saved File_Contents are overlaid
// on the Problem_Template defaults: every default file is present unless the
// saved snapshot overrides it, and any file the Learner created (a key in the
// saved map absent from the defaults) survives the persist-then-resume cycle.

export type FileContents = { [path: string]: string };

/**
 * Merge saved File_Contents over template defaults.
 *
 * The result's key set is the union of both maps; values come from `saved`
 * wherever it defines a path, and from `templateDefaults` otherwise.
 */
export function resolveWorkingContents(
 templateDefaults: FileContents,
 saved: FileContents | null | undefined,
): FileContents {
 const resolved: FileContents = { ...templateDefaults };
 if (saved) {
  for (const [path, contents] of Object.entries(saved)) {
   resolved[path] = contents;
  }
 }
 return resolved;
}
